import React, { useCallback, useEffect, useMemo, useState } from 'react';
import Avatar from 'components/avatarComponent';
import { useAuth } from 'auth/context/AuthContext';
import { useGetSignUrlFromStorageForRequesterLazyQuery } from 'graphql/generated/hasura';

interface PatientAvatarMobileProps {
  openNavbarMobile: () => void;
  profilePicture?: string;
}

const PatientAvatarMobile: React.FC<PatientAvatarMobileProps> = ({
  openNavbarMobile,
  profilePicture,
}) => {
  const { selectedAccount, user, avatarMap } = useAuth();
  const id = useMemo(
    () => selectedAccount || user?.uuid || '',
    [selectedAccount, user?.uuid],
  );
  const [avatarUrl, setAvatarUrl] = useState<string | null>(
    avatarMap?.get(id) ?? null,
  );
  const [getFileUrlFromStorageForRequester] =
    useGetSignUrlFromStorageForRequesterLazyQuery();

  const getAvatar = useCallback(async () => {
    let profileImage = null;
    if (!profilePicture || !id) return profileImage;
    if (avatarMap?.has(id)) {
      return avatarMap?.get(id);
    }
    profileImage = await getFileUrlFromStorageForRequester({
      variables: {
        fileId: profilePicture,
        requestedUserId: id,
      },
    });
    return profileImage?.data?.GetSignUrlFromStorageForRequester?.url;
  }, [avatarMap, getFileUrlFromStorageForRequester, id, profilePicture]);

  useEffect(() => {
    getAvatar()
      .then((image) => {
        setAvatarUrl(image ?? '');
      })
      .catch((error) => console.error(error));
  }, [getAvatar]);

  return (
    <div className="flex flex-col desktop:hidden">
      <div
        className="flex h-[70px] w-[45px] items-center justify-center cursor-pointer"
        onClick={openNavbarMobile}
      >
        <Avatar size="xs" imageUrl={avatarUrl} key={avatarUrl} />
      </div>
    </div>
  );
};

export default PatientAvatarMobile;
